export default [{
  path: '/questions',
  name: 'question',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/quiz/question/index')
}]
